/* Control unificado del carrusel: [<] con indicadores en medio y [>]. No
   reimplementa el carrusel, lo maneja: por scroll, o pidiendole paginas al
   slider del tema. Es un custom element porque las tabs inyectan su contenido
   con innerHTML y un <script> inline no se ejecutaria. Ver README-gpets.md. */
class CarouselControls extends HTMLElement {
  connectedCallback() {
    if (this.tp_initialized) return;
    this.tp_initialized = true;

    /* El envoltorio: cualquier contenedor marcado con data-carousel-root, o el
       de la seccion de productos, que es anterior a este atributo. */
    this.items = this.closest('[data-carousel-root]') || this.closest('.featured-collection-items');
    if (!this.items) return;

    /* Con data-scroll-always el carrusel navega por scroll en TODOS los anchos.
       Sin el, solo en movil, y en escritorio pagina con las flechas del tema
       (que es como funciona el carrusel de productos). */
    this.scroll_always = this.hasAttribute('data-scroll-always');

    this.slider = this.items.querySelector('slider-component');
    if (!this.slider) return;

    this.theme_prev = this.items.querySelector('.slider-desktop__buttons__prev');
    this.theme_next = this.items.querySelector('.slider-desktop__buttons__next');

    this.prev = this.querySelector('.gpets-controls__arrow--prev');
    this.next = this.querySelector('.gpets-controls__arrow--next');
    this.dots_box = this.querySelector('.gpets-controls__dots');
    this.dots = [];
    this.pages = 0;

    this.prev.addEventListener('click', this.onPrev.bind(this));
    this.next.addEventListener('click', this.onNext.bind(this));

    this.onScroll = this.frameThrottle(this.render.bind(this));
    this.slider.addEventListener('scroll', this.onScroll, { passive: true });
    window.addEventListener('resize', this.frameThrottle(this.build.bind(this)));

    // Se vuelve a medir al terminar de cargar, cuando las imagenes ya ocupan su
    // sitio. NO usar un ResizeObserver aqui: entra en bucle y congela la tienda.
    window.addEventListener('load', this.frameThrottle(this.build.bind(this)));

    // El slider de escritorio se inicializa con un setTimeout de 100ms en
    // global.js: antes de eso desktop_pages todavia no existe.
    this.build();
    setTimeout(this.build.bind(this), 250);
  }

  frameThrottle(fn) {
    var waiting = false;
    return function () {
      if (waiting) return;
      waiting = true;
      requestAnimationFrame(function () {
        waiting = false;
        fn();
      });
    };
  }

  /* Si se navega por scroll o pidiendole paginas al tema. */
  isMobile() {
    return this.scroll_always || window.innerWidth <= 576;
  }

  slides() {
    return this.slider.querySelectorAll('.slider__slide');
  }

  /* Cuantas posiciones tiene el carrusel en el breakpoint actual. */
  pageCount() {
    if (this.isMobile()) {
      // Sin la clase slider--phone no hay scroll horizontal en movil. Con
      // data-scroll-always el scroll lo pone la hoja de la seccion.
      if (!this.scroll_always && !this.slider.classList.contains('slider--phone')) return 0;

      var slides = this.slides();
      if (slides.length < 2) return 0;
      var step = slides[1].offsetLeft - slides[0].offsetLeft;
      if (step <= 0) return 0;

      // Posiciones a las que se puede llegar, no tarjetas. Si caben todas, el
      // recorrido es cero y el control sobra: se esconde solo.
      var max = this.slider.scrollWidth - this.slider.clientWidth;
      if (max <= 1) return 0;
      return Math.round(max / step) + 1;
    }
    // desktop_pages es el indice de la ultima pagina, no la cantidad.
    if (typeof this.slider.desktop_pages !== 'number') return 0;
    return this.slider.desktop_pages + 1;
  }

  currentPage() {
    if (this.isMobile()) {
      var slides = this.slides();
      if (slides.length < 2) return 0;
      var step = slides[1].offsetLeft - slides[0].offsetLeft;
      if (step <= 0) return 0;
      // Se acota contra las posiciones reales, no contra el numero de tarjetas:
      // al final del recorrido varias tarjetas comparten la ultima posicion.
      return Math.min(Math.round(this.slider.scrollLeft / step), this.pages - 1);
    }
    return Number(this.slider.getAttribute('data-page')) || 0;
  }

  // El carrusel da la vuelta, por eso las flechas nunca se apagan.
  onPrev() {
    var current = this.currentPage();
    this.goTo(current <= 0 ? this.pages - 1 : current - 1);
  }

  onNext() {
    var current = this.currentPage();
    this.goTo(current >= this.pages - 1 ? 0 : current + 1);
  }

  goTo(page) {
    page = Math.max(0, Math.min(page, this.pages - 1));

    if (this.isMobile()) {
      var slides = this.slides();
      if (!slides[page]) return;
      // El scroll-padding se descuenta a mano: el navegador solo lo respeta
      // cuando el deslizamiento lo hace el dedo, no con un scrollTo.
      var pad = parseFloat(getComputedStyle(this.slider).scrollPaddingLeft) || 0;
      this.slider.scrollTo({
        left: Math.max(slides[page].offsetLeft - pad, 0),
        behavior: 'smooth'
      });
      return;
    }

    // El tema solo avanza de a una pagina: para saltar lejos se le pide varias
    // veces. Su pointer-events:none en los extremos no frena un .click() por codigo.
    var diff = page - this.currentPage();
    var button = diff > 0 ? this.theme_next : this.theme_prev;
    if (!button) return;
    for (var i = 0; i < Math.abs(diff); i++) button.click();
    this.render();
  }

  build() {
    var count = this.pageCount();

    // Con una sola pagina no hay nada que navegar.
    if (count < 2) {
      this.hidden = true;
      this.pages = count;
      return;
    }
    this.hidden = false;

    if (count !== this.pages) {
      this.pages = count;
      this.dots_box.innerHTML = '';
      this.dots = [];
      for (var i = 0; i < count; i++) {
        var dot = document.createElement('button');
        dot.type = 'button';
        dot.className = 'gpets-controls__dot';
        dot.setAttribute('aria-label', 'Ir al grupo ' + (i + 1));
        dot.addEventListener('click', this.goTo.bind(this, i));
        this.dots_box.appendChild(dot);
        this.dots.push(dot);
      }
    }

    this.render();
  }

  render() {
    if (this.hidden || !this.dots.length) return;
    var current = this.currentPage();

    for (var i = 0; i < this.dots.length; i++) {
      this.dots[i].classList.toggle('gpets-controls__dot--current', i === current);
    }
  }
}
/* Con guarda: lo cargan varias secciones, y dos <script> con el mismo src se
   ejecutan las dos veces. Sin esto, el segundo define() lanza una excepcion y
   tumba el resto del script. */
if (!customElements.get('carousel-controls')) {
  customElements.define('carousel-controls', CarouselControls);
}
